module.exports = __webpack_public_path__ + "img/sr-goiaba.6fa855ea.png";